import React from "react";
import { motion } from "framer-motion";
import { Instagram, Youtube, Play } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const POSTS = [
  "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1604480133080-602261a680df?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=600&q=80",
];

export default function ContentPreview() {
  const { t } = useI18n();
  return (
    <section id="content" className="py-24 sm:py-32" data-testid="content-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-6">
          <div>
            <div className="text-xs tracking-[0.4em] text-[#FF6B00] uppercase">{t.content.eyebrow}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 uppercase">{t.content.title}</h2>
            <p className="mt-4 text-zinc-400 max-w-xl">{t.content.subtitle}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://www.instagram.com/jorgemasterfit/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border border-white/20 text-white px-5 py-3 text-xs tracking-[0.25em] uppercase hover:border-[#FF6B00] hover:text-[#FF6B00] transition"
              data-testid="follow-instagram"
            >
              <Instagram size={16} /> {t.content.followBtn}
            </a>
            <a
              href="https://www.youtube.com/@jorgemasterfit"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B00] text-black px-5 py-3 text-xs tracking-[0.25em] uppercase btn-glow"
              data-testid="follow-youtube"
            >
              <Youtube size={16} /> {t.content.watchBtn}
            </a>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-3 sm:gap-4">
          {/* Featured video */}
          <a
            href="https://www.youtube.com/@jorgemasterfit"
            target="_blank"
            rel="noopener noreferrer"
            className="col-span-12 lg:col-span-6 row-span-2 relative aspect-square lg:aspect-auto overflow-hidden zoom-wrap group"
            data-testid="featured-video"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_elite-fitness-jorge/artifacts/c3d2b1g2_03_coaching_worldgym.jpg"
              alt="Featured"
              className="absolute inset-0 w-full h-full object-cover zoom-img"
            />
            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 rounded-full bg-[#FF6B00] flex items-center justify-center btn-glow">
                <Play size={28} fill="black" className="text-black ml-1" />
              </div>
            </div>
            <div className="absolute bottom-4 left-4 right-4">
              <div className="text-[10px] tracking-[0.3em] text-[#FF6B00] uppercase">YOUTUBE</div>
              <div className="font-display text-2xl mt-1 uppercase">@jorgemasterfit</div>
            </div>
          </a>

          {POSTS.slice(0, 6).map((p, i) => (
            <motion.a
              key={i}
              href="https://www.instagram.com/jorgemasterfit/"
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="col-span-6 lg:col-span-3 relative aspect-square overflow-hidden zoom-wrap group"
              data-testid={`ig-post-${i}`}
            >
              <img src={p} alt="" className="absolute inset-0 w-full h-full object-cover zoom-img" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition flex items-center justify-center">
                <Instagram size={28} className="text-white opacity-0 group-hover:opacity-100 transition" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
